import {
  PASSWORD_RESET_REQUEST_EMAIL_SUCCESS,
  PASSWORD_RESET_REQUEST_EMAIL_FAILURE,
  SET_NEW_PASSWORD_SUCCESS,
  SET_NEW_PASSWORD_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { requestMailError: [], changePasswordError: [] };

export default function resetPassword(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PASSWORD_RESET_REQUEST_EMAIL_FAILURE:
      return { ...state, requestMailError: action.payload.response && action.payload.response.data.errors };
    case PASSWORD_RESET_REQUEST_EMAIL_SUCCESS:
      return { ...state, requestMailError: [] };
    case SET_NEW_PASSWORD_FAILURE:
      return { ...state, changePasswordError: action.payload.response && action.payload.response.data.errors };
    case SET_NEW_PASSWORD_SUCCESS:
      return { ...state, changePasswordError: [] };
    default:
      return state;
  }
}
